import React, {Component} from "react";
import styles from "./services.module.scss";
import appweb from '../../../static/images/application-web.jpg';
import portail from '../../../static/images/portail-intranet-extranet.jpg';
import ecommerce from '../../../static/images/e-commerce.jpg';
import site from '../../../static/images/site-internet.jpg';
import iot from '../../../static/images/iot.jpg';
import appmobile from '../../../static/images/application-mobile.jpg';



class Services extends Component {
    render() {
        let services = [
            {
                title: 'Application Web',
                subtitle: 'Développement d\'applications web',
                image: appweb,
                description: 'Notre équipe, composée de passionnés du Web, vous accompagne dans la réalisation d\'application sur-mesure. Nous prenons en compte l\'ensemble de votre système d\'information afin d\'intégrer au mieux les apps que nous réalisons !',
                url: '/application-web'
            },
            {
                title: 'Portail collaboratif',
                subtitle: ' Réalisation de portails Intranet / Extranet',
                image: portail,
                description: 'Les portails Web d\'entreprise ont pour objectif d\'améliorer l\'efficacité quotidienne de l\'ensemble des collaborateurs d\'une organisation. Nos équipes, fortes de plusieurs années d\'expérience dans le domaine des portails d\'entreprises, vous accompagnent et vous conseillent afin de concevoir et réaliser des sites intranet et extranet en accord avec vos besoins tout en respectant les contraintes de votre métier.',
                url: '/portail-web-collaboratif'
            },
            {
                title: 'Site E-commerce',
                subtitle: ' Réalisation de site E-Commerce innovants et performants',
                image: ecommerce,
                description: 'Notre expérience dans la vente en ligne est très diversifiée. Nous vous accompagnons pour réaliser des sites E-Commerce B to B, les sites E-Commerce B to C, les vitrines de produits ou encore de catalogue en ligne.',
                url: '/e-commerce'
            },
            {
                title: 'Sites Internet',
                subtitle: ' Nous imaginons de superbes sites vitrines à votre image',
                image: site,
                description: 'Parce qu\'internet évolue tous les jours, nous sommes à l\'écoute de vos besoins au quotidien, et intervenons dans les meilleurs délais afin de faire évoluer et renforcer votre présence sur les réseaux. De plus notre expérience nous permet de vous conseiller pour la mise en place de votre stratégie E-Marketing.',
                url: '/site-internet'
            },
            {
                title: 'Application IoT',
                subtitle: ' Création d\'applications IoT (Objets connectés) ',
                image: iot,
                description: 'L\'internet des objets représente l\'extension d\'Internet à des choses et à des lieux du monde physique. Ainsi l\'IoT (Internet Of Things) permet l\'échange d\'informations provenant d\'objets physiques et réels et le réseau Internet. Integral Service de par son expertise Web ainsi que son expertise industrielle se positionne comme un acteur logique du marché de l\'IoT.',
                url: '/application-iot'
            },
            {
                title: 'Applications mobile',
                subtitle: 'Des apps iOS et Android',
                image:  appmobile,
                description: 'Afin de compléter notre offre de service 360°, nous proposons de vous aider dans la réalisation d\'applications mobiles sur-mesure. Que ce soit pour des environnements Apple ou Google Android, nos équipes vous accompagnent afin de réaliser l\'app que vous souhaitez !',
                url: '/application-mobile'
            },

        ];
        let servicesHmtlList = (
            <div>
                {services.map((service,index) =>
                    <section className={styles.serviceSection}>
                        <div className="container">
                            <div className="row align-items-center">
                                <div className="col-12">

                                    <div className={`row row-bottom-padded-md row-top-padded-md ${styles.serviceContent} ${(index%2?'flex-row-reverse':'flex-row')}`}>
                                        <div className='col-md-4 align-self-stretch text-center'>
                                        <img src={service.image} alt={service.title} className={`text-sm-center ${styles.projectimg}`}/>
                                        </div>
                                        <div className="col-md-8">
                                            <h2 className="text-center text-md-left p-0 col-12 mb-2">{service.title}</h2>
                                            <h3 className="text-center text-md-left p-0 col-12">{service.subtitle}</h3>
                                            <p className="text-justify d-flex align-items-center">
                                            {service.description}
                                            </p>
                                            <div className="col-md-12 p-0 d-flex justify-content-md-start justify-content-center">
                                                <a  href={service.url} title={'En savoir plus sur  les '+service.title}><button className="btn btn-primary">En savoir plus ! </button></a>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </section>
                )}
            </div>

        );

        return (
            <div className="serviceList">
                {servicesHmtlList}
            </div>
        );
    }
}

export default Services;



// WEBPACK FOOTER //
// ./src/components/Page/Services.jsx